import React, { useState } from "react";
import styles from "./TableComponent.module.css";
import AccountName from "../AccountName";

const TableSecond = ({ strategies, data, userStatus, ...props }) => {
  const [expandedSymbols, setExpandedSymbols] = useState([]);

  const toggleCollapse = (symbol) => {
    setExpandedSymbols((prevSymbols) => {
      if (prevSymbols.includes(symbol)) {
        return prevSymbols.filter((prevSymbol) => prevSymbol !== symbol);
      } else {
        return [...prevSymbols, symbol];
      }
    });
  };

  return (
    <table className={`${styles.table}`}>
      <thead>
        <tr>
          <th scope="col">Symbol</th>
          <th scope="col">Live ?</th>
          <th scope="col">Size</th>
          <th scope="col">Account</th>
          {strategies &&
            strategies.map((ele, i) => (
              <th scope="col" key={i}>
                {ele}
                <span className="flex flex-row border-t border-[#ffffff]/10 mt-2">
                  <span
                    className={
                      "w-[33.33%]  text-center border-r border-[#ffffff]/20"
                    }
                  >
                    O
                  </span>
                  <span
                    className={
                      "w-[33.33%] text-center border-r border-[#ffffff]/20"
                    }
                  >
                    P
                  </span>
                  <span className={"w-[33.33%] text-center "}>S</span>
                </span>
              </th>
            ))}
        </tr>
      </thead>
      <tbody>
        {data &&
          [...new Set(data.map((ele) => ele.symbol))].map((symbol, i) => {
            const rowsForSymbol = data.filter((row) => row.symbol === symbol);
            const uniqueClientIds = [
              ...new Set(rowsForSymbol.map((row) => row.clientId)),
            ];

            return (
              <React.Fragment key={i}>
                <tr
                  onClick={() => toggleCollapse(symbol)}
                  className="cursor-pointer"
                >
                  <td className="items-center px-4 py-1">{symbol}</td>
                </tr>
                {expandedSymbols.includes(symbol) &&
                  uniqueClientIds.map((clientId, j) => {
                    const clientRows = rowsForSymbol.filter(
                      (row) => row.clientId === clientId
                    );

                    return (
                      <tr key={`${i}-${clientId}`}>
                        <td className="items-center px-4 py-1"></td>
                        <td className="items-center px-4 py-1">
                          {userStatus &&
                            userStatus.map((ele, i) => {
                              return (
                                <span key={i}>
                                  {ele.client_id === clientId ? ele.status : ""}
                                </span>
                              );
                            })}
                        </td>
                        <td className="items-center px-4 py-1">
                          {userStatus &&
                            userStatus.map((ele, i) => {
                              return (
                                <span key={i}>
                                  {ele.client_id === clientId
                                    ? ele.index_multiplier
                                    : ""}
                                </span>
                              );
                            })}
                        </td>
                        <td className="items-center px-4 py-1">
                          <AccountName
                            accountName={props.accountName}
                            clientId={clientId}
                          />
                        </td>
                        {strategies &&
                          strategies.map((strategy, k) => {
                            const strategyRows = clientRows.filter(
                              (row) => row.strategy === strategy
                            );

                            return (
                              <td key={k} scope="col">
                                <span className="flex flex-row mt-2">
                                  {strategyRows.map((row, l) => (
                                    <span
                                      key={l}
                                      className="w-[33.33%] text-center border-r border-[#ffffff]/20"
                                    >
                                      {row.strategy === strategy &&
                                      row.clientId === clientId &&
                                      row.side === 1 &&
                                      row.status === 6
                                        ? row.qty
                                        : "-"}
                                    </span>
                                  ))}
                                  {strategyRows.map((row, l) => (
                                    <span
                                      key={l}
                                      className="w-[33.33%] text-center border-r border-[#ffffff]/20"
                                    >
                                      {row.strategy === strategy &&
                                      row.clientId === clientId &&
                                      row.side === 1 &&
                                      row.status === 2
                                        ? row.qty
                                        : "-"}
                                    </span>
                                  ))}
                                  {strategyRows.map((row, l) => (
                                    <span
                                      key={l}
                                      className="w-[33.33%] text-center border-r border-[#ffffff]/20"
                                    >
                                      {row.strategy === strategy &&
                                      row.clientId === clientId &&
                                      row.side === -1 &&
                                      row.status === 6
                                        ? row.qty
                                        : "-"}
                                    </span>
                                  ))}
                                </span>
                              </td>
                            );
                          })}
                      </tr>
                    );
                  })}
              </React.Fragment>
            );
          })}
      </tbody>
    </table>
  );
};

export default TableSecond;
